import React, { useState } from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import classes from "./DisableAccount.module.css";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { TextArea } from "../../../../../stories/TextArea/TextArea";

export default function DisableAccountModal({ show, setShow }) {
  const [tellUs, setTellUs] = useState();
  const [disable, setDisable] = useState();
  const [password, setPassword] = useState();

  const options = [
    {
      label: "Students rarely book lessons",
      value: "Students rarely book lessons",
    },
    { label: "Privacy concerns", value: "Privacy concerns" },
    { label: "Just need a break", value: "Just need a break" },
    { label: "Something else", value: "Something else" },
    { label: "Other", value: "Other" },
  ];

  return (
    <>
      <style>{`
              @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 80% !important;
              margin: 0px 10%;
            }
      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={{ padding: "0px", margin: "0px" }}
        width={"509px"}
        header={
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Temporarily Disable Your Account
          </h4>
        }
        footer={
          <div className={classes.footerBtns}>
            <Button
              label={"Cancel"}
              primary={false}
              size={"Large"}
              customStyle={{
                width: "95px",
                marginRight: "20px",
                backgroundColor: Colors.white,
                border: "none",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              onClick={() => setShow(false)}
            />
            <Button
              label={"Disable account"}
              primary={true}
              size={"Large"}
              customStyle={{
                width: "max-content",
                height: "48px",
                ...Fonts.b2,
                lineHeight: "20px",
                padding: "14px 24px",
              }}
              onClick={() => setShow(false)}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          <div className={[classes.mb24].join(" ")}>
            <DropDown
              options={options}
              state={disable}
              setter={setDisable}
              placeholder="Select"
              label="Why are you disabling your account?"
            />
          </div>

          {disable?.value === "Other" && (
            <div className={[classes.mb24].join(" ")}>
              <TextArea
                type="text"
                state={tellUs}
                setter={setTellUs}
                label="Tell us more"
                placeholder="Type your reason here..."
                textAreaStyle={{ minHeight: "72px" }}
              />
            </div>
          )}

          <div className={[classes.mb24].join(" ")}>
            <Input
              type="password"
              state={password}
              setter={setPassword}
              label="To continue, please re-enter your password"
              placeholder="Password"
            />
          </div>
          <div>
            <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
              When you press the button below, your profile will be hidden until
              you reactivate your account by logging back in.
            </p>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
}
